export const fundinground = [
  'Pre-Seed', 'Seed', 'Series A', 'Series B', 'Series C'
]

export default fundinground
